/**
 * Utility script for implementing recaptcha with Vision 6 forms
 **/
function submitToVision6(config) {
  return new Promise(function (resolve, reject) {
    var token = config.token;
    var form =
      typeof config.form === "string"
        ? document.getElementById(config.form)
        : config.form;
    var fields = form.querySelectorAll("[name]");
    var body = {
      "g-recaptcha-response": token,
    };

    if (!form) {
      return reject({ success: false, message: "Form not found" });
    }

    /**
     * manually trigger html required validation
     */
    if (!form.checkValidity()) {
      var button = document.createElement("button");
      form.appendChild(button);
      button.click();
      button.remove();
      return reject({ success: false, message: "Form is invalid" });
    }

    fields.forEach(function (field) {
      var value = field.value;

      if (field.type === "checkbox" && field.checked) {
        value = "true";
      }

      body[field.name] = value;
    });

    $.post("", body, function (response) {
      var data = typeof response === "string" ? JSON.parse(response) : response;
      if (data.success) {
        form.reset();
        resolve(data);
      } else {
        reject(data);
      }
    });
  });
}

/**
 * Utility for enabling/disabling a form button.
 * recaptcha will disable the button on click, but will enable shortly after.
 * However, the button has to stay disabled until the form is submitted and the response has been received.
 */
function enableButton(button, enable = true) {
  var classes = button.getAttribute("class").split("disabled").join("").trim();
  if (enable === false) {
    classes += " disabled";
  }
  button.setAttribute("class", classes);
}
